import { phoneNumberRegex } from './regex';

export const isArrowKey = (key: string) => {
  const isUp = key.toLowerCase() === 'arrowup';
  const isDown = key.toLowerCase() === 'arrowdown';
  const isLeft = key.toLowerCase() === 'arrowleft';
  const isRight = key.toLowerCase() === 'arrowright';
  return isUp || isDown || isLeft || isRight;
};

export const isNumericKey = (key: string) => /^\d$/.test(key);

export const isModifierKey = (event: any) => {
  const { key } = event;

  // check for supported browser
  if (event.key) {
    const isShift = event.shiftKey === true;
    const isHome = key.toLowerCase() === 'home';
    const isEnd = key.toLowerCase() === 'home';
    const isBackSpace = key.toLowerCase() === 'backspace';
    const isEnter = key.toLowerCase() === 'enter';
    const isDelete = key.toLowerCase() === 'delete';
    const isControl = event.ctrlKey === true;
    const isCmd = event.metaKey === true;
    const isA = key.toLowerCase() === 'a';
    const isC = key.toLowerCase() === 'c';
    const isV = key.toLowerCase() === 'v';
    const isX = key.toLowerCase() === 'x';
    const isZ = key.toLowerCase() === 'z';

    const isCombo =
      (isControl || isCmd) && (isA || isC || isV || isX || isZ);

    return (
      isShift ||
      isHome ||
      isEnd ||
      isBackSpace ||
      isEnter ||
      isDelete ||
      isArrowKey(key) ||
      isCombo
    );
  }

  return (
    event.shiftKey === true ||
    key === 35 ||
    key === 36 || // Allow Shift, Home, End
    key === 8 ||
    key === 9 ||
    key === 13 ||
    key === 46 || // Allow Backspace, Tab, Enter, Delete
    (key > 36 && key < 41) || // Allow left, up, right, down
    // Allow Ctrl/Command + A,C,V,X,Z
    ((event.ctrlKey === true || event.metaKey === true) &&
      (key === 65 || key === 67 || key === 86 || key === 88 || key === 90))
  );
};

export const isValidPhoneNumber = (str: string) =>
  phoneNumberRegex.test(str);
